import React from 'react';
import { Modal, Space, Typography, Card, Button, Divider, Row, Col } from 'antd';
import { CheckCircleFilled, EnvironmentOutlined, SwapOutlined, QuestionCircleOutlined } from '@ant-design/icons';

const AddressConfirmationModal = ({ 
  visible, 
  onUpdateAddress, 
  onContinueWithoutUpdate, 
  onCancel,
  currentAddress,
  newAddress
}) => {
  // Helper function to format address
  const formatAddress = (address) => {
    if (!address) return null;
    
    return (
      <>
        <Typography.Paragraph style={{ marginBottom: 4, fontSize: 15 }}>
          {address.street_address}
        </Typography.Paragraph>
        {address.street_address2 && (
          <Typography.Paragraph style={{ marginBottom: 4, fontSize: 15 }}>
            {address.street_address2}
          </Typography.Paragraph>
        )}
        <Typography.Paragraph style={{ marginBottom: 0, fontSize: 15 }}>
          {address.city}, {address.state} {address.zip}
        </Typography.Paragraph>
      </>
    );
  };

  return (
    <Modal
      title={
        <Space align="center">
          <QuestionCircleOutlined style={{ color: '#1890ff', fontSize: 22 }} />
          <Typography.Title level={4} style={{ margin: 0 }}>
            Update Default Address?
          </Typography.Title>
        </Space>
      }
      open={visible}
      onCancel={onCancel}
      footer={null}
      width={600}
      centered
      style= {{ }}
      // Increase horizontal padding to create a better side buffer
      //bodyStyle={{ padding: '24px 40px' }}
      //className="address-confirmation-modal"
    >
      <Typography.Paragraph style={{ fontSize: 16, marginBottom: 24, lineHeight: 1.6, marginLeft: 20, marginRight: 20 }}>
        The shipping address you entered is different from your default address.
        Would you like to update your default address with this shipping address?
      </Typography.Paragraph>
      
      <Row gutter={[24, 24]} style={{ marginBottom: 24, marginLeft: 10, marginRight: 10 }}>
        <Col xs={24} md={11}>
          <Card 
            title={
              <Space>
                <EnvironmentOutlined />
                <span>Current Default Address</span>
              </Space>
            }
            style={{ 
              height: '100%',
              backgroundColor: '#fafafa',
              border: '1px solid #d9d9d9',
              borderRadius: 8
            }}
            headStyle={{ 
              backgroundColor: '#f5f5f5',
              borderBottom: '1px solid #d9d9d9',
              padding: '12px 16px',
              borderRadius: '8px 8px 0 0'
            }}
            bodyStyle={{ padding: 16 }}
          >
            {formatAddress(currentAddress)}
          </Card>
        </Col>
        
        <Col xs={24} md={2} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <SwapOutlined style={{ fontSize: 24, color: '#1890ff' }} />
        </Col>
        
        <Col xs={24} md={11}>
          <Card 
            title={
              <Space>
                <EnvironmentOutlined />
                <span>New Shipping Address</span>
              </Space>
            }
            style={{ 
              height: '100%',
              backgroundColor: '#e6f7ff',
              border: '1px solid #1890ff',
              borderRadius: 8
            }}
            headStyle={{ 
              backgroundColor: '#bae7ff',
              borderBottom: '1px solid #1890ff',
              padding: '12px 16px',
              borderRadius: '8px 8px 0 0'
            }}
            bodyStyle={{ padding: 16 }}
          >
            {formatAddress(newAddress)}
          </Card>
        </Col>
      </Row>
      
      <Divider style={{ marginBottom: 24 }} />
      
      <Space direction="vertical" size="large" style={{ width: '100%'}} >
        <Button
          type="primary"
          size="large"
          block
          onClick={onUpdateAddress}
          style = { {width: "60%", marginInline: "20%"} }
          icon={<CheckCircleFilled />}
        >
          Yes, update my default address
        </Button>
        
        <Button 
          size="large" 
          block
          onClick={onContinueWithoutUpdate}
          style={{ width: "60%", marginInline: "20%", marginBlockEnd: "5%" }}
        >
          No, just use this address for this order
        </Button>
      </Space>
    </Modal>
  );
};

export default AddressConfirmationModal;